module.exports = __webpack_public_path__ + "images/181_640.jpg";